import styled from 'styled-components';
import { Layout } from 'antd';

const Content = styled(Layout.Content).withConfig<{ isScrollable?: boolean }>({
  shouldForwardProp: (props) => props !== 'isScrollable',
})`
  height: ${({ isScrollable }) => (isScrollable ? 'auto' : 'calc(100vh - 48px)')};
  min-height: calc(100vh - 48px);
  background: #e5e5e8;
`;

export { Content };
